import { call, put } from "redux-saga/effects";
import {
  GetAdditionalInfo_Api,
  UpdateAdditionalInfo_Api,
} from "../Apis/AdditionalInfoApi";
import { Decrypt_Value } from "../EncryptDecrypt";
import {
  SetAdditionalInfoLoading,
  SetAdditionalInfo,
  SetUpdateAdditionalInfoResponse,
} from "../../StateManagement/Reducers/AdditionalInfoState";
import { toast } from "react-toastify";
import Success from "../../Modules/StyledComponents/Toastify/Success";
import Error from "../../Modules/StyledComponents/Toastify/Error";

export function* GetAdditionalInfoWorker() {
  try {
    yield put(SetAdditionalInfoLoading(true));
    const response = yield call(GetAdditionalInfo_Api);
    if (response?.status === 200) {
      const decryptedData = Decrypt_Value(response?.data, "vozo");
      yield put(SetAdditionalInfo(decryptedData));
    }
  } catch (error) {
    console.error("GetAdditionalInfoWorker error", error);
  } finally {
    yield put(SetAdditionalInfoLoading(false));
  }
}

export function* UpdateAdditionalInfoWorker(action) {
  try {
    yield put(SetAdditionalInfoLoading(true));
    const response = yield call(UpdateAdditionalInfo_Api, action.payload);
    if (response?.status === 200) {
      yield put(SetUpdateAdditionalInfoResponse(response?.data));
      toast(<Success msg="Additional Info updated successfully" />, {
        containerId: "A",
      });
    } else {
      toast(<Error msg="Failed to update Additional Info" />, {
        containerId: "B",
        className: "error_badge",
      });
    }
  } catch (error) {
    console.error("UpdateAdditionalInfoWorker error", error);
    toast(<Error msg="Failed to update Additional Info" />, {
      containerId: "B",
      className: "error_badge",
    });
  } finally {
    yield put(SetAdditionalInfoLoading(false));
  }
}
